import React, { useState } from "react";
import Logo from "../assets/logo.jpg";

const styles = `
  .bev-hdr { background: #fff; border-bottom: 1px solid #e8e8e8; position: sticky; top: 0; z-index: 1030; font-family: 'Montserrat', 'Segoe UI', sans-serif; }
  .bev-hdr-inner { max-width: 1200px; margin: 0 auto; padding: 0 24px; display: flex; align-items: center; height: 70px; gap: 0; }
  .bev-hdr-logo img { height: 60px; width: auto; display: block; }
  .bev-hdr-links { display: flex; align-items: center; margin-left: 24px; list-style: none; padding: 0; margin-bottom: 0; flex-wrap: nowrap; gap: 0; }
  .bev-hdr-links a { display: block; padding: 8px 11px; font-size: 0.86rem; font-weight: 500; color: #222; text-decoration: none; border-radius: 6px; transition: color 0.2s; white-space: nowrap; }
  .bev-hdr-links a:hover { color: #00C261; }
  .bev-hdr-links .has-drop { position: relative; }
  .bev-hdr-links .has-drop > a::after { content: ' ▾'; font-size: 0.75rem; color: #666; }
  .bev-hdr-links .drop-menu { display: none; position: absolute; top: calc(100% + 4px); left: 0; background: #fff; border: 1px solid #e8e8e8; border-radius: 10px; padding: 8px 0; min-width: 200px; box-shadow: 0 8px 24px rgba(0,0,0,0.10); z-index: 100; }
  .bev-hdr-links .has-drop:hover .drop-menu { display: block; }
  .bev-hdr-links .drop-menu a { padding: 9px 18px; border-radius: 0; color: #333; font-size: 0.88rem; }
  .bev-hdr-links .drop-menu a:hover { background: #f5f5f5; color: #00C261; }
  .bev-hdr-right { margin-left: auto; display: flex; align-items: center; gap: 16px; }
  .bev-hdr-translate { display: flex; align-items: center; position: relative; }
  .bev-hdr-translate .gt-arrow { position: absolute; right: 12px; pointer-events: none; font-size: 0.72rem; color: #555; }
  .bev-hdr-toggler { display: none; background: none; border: 1px solid #ccc; border-radius: 6px; padding: 6px 10px; cursor: pointer; margin-left: auto; }
  .bev-hdr-toggler span { display: block; width: 22px; height: 2px; background: #333; margin: 4px 0; }
  @media (max-width: 991px) {
    .bev-hdr-links { display: none; order: 3; width: 100%; margin-left: 0; }
    .bev-hdr-right { display: none; order: 4; width: 100%; }
    .bev-hdr-toggler { display: block; order: 2; margin-left: auto; }
    .bev-hdr-logo { order: 1; }
    .bev-hdr-inner { flex-wrap: wrap; height: auto; padding: 12px 16px; }
    .bev-hdr-links.open { display: flex; flex-direction: column; position: static; background: #fff; border-bottom: 1px solid #f0f0f0; padding: 12px 0 8px; gap: 4px; width: 100%; margin-left: 0; }
    .bev-hdr-links.open .has-drop .drop-menu { display: block; position: static; box-shadow: none; border: none; padding: 4px 0 4px 16px; min-width: 0; }
    .bev-hdr-links.open .has-drop .drop-menu a { padding: 8px 12px; font-size: 0.85rem; }
    .bev-hdr-right.open { display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; position: static; background: #fff; border-bottom: 1px solid #e8e8e8; padding: 12px 0; gap: 16px; width: 100%; margin-left: 0; }
  }
`;

const BevHeader = () => {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => setOpen((o) => !o);

  return (
    <>
      <style>{styles}</style>
      <header className="bev-hdr">
        <div className={`bev-hdr-inner${open ? " menu-open" : ""}`}>
          <a href="https://bevogtet.com" className="bev-hdr-logo">
            <img src={Logo} alt="Bevogtet" />
          </a>
          <ul className={`bev-hdr-links${open ? " open" : ""}`}>
            <li><a href="https://bevogtet.com/#whatwedo">What we Do</a></li>
            <li><a href="https://bevogtet.com/#features">Features</a></li>
            <li><a href="https://bevogtet.com/#gadgets">Products</a></li>
            <li><a href="https://bevogtet.com/faq">FAQ</a></li>
            <li className="has-drop">
              <a href="#">Downloads</a>
              <div className="drop-menu">
                <a href="https://bevogtet.com/img/BevogtetPartnersBrochure.pdf" download="BevogtetPartnersBrochure.pdf">Channel Partner</a>
                <a href="https://bevogtet.com/img/BevogtetBrochure.pdf" download="BevogtetBrochure.pdf">Customer</a>
              </div>
            </li>
            <li className="has-drop">
              <a href="#">Channel Partner</a>
              <div className="drop-menu">
                <a href="https://bevogtet.com/channel-partner.html">Know about Program</a>
                <a href="https://bevogtet.com/partner/register">Channel Partner Registration</a>
              </div>
            </li>
          </ul>
          <button className="bev-hdr-toggler" onClick={toggleMenu} aria-label="Menu">
            <span /><span /><span />
          </button>
          <div className={`bev-hdr-right${open ? " open" : ""}`}>
            <div className="bev-hdr-translate" aria-label="Language translate">
              <span className="gt-arrow">▾</span>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default BevHeader;
